module.exports = __webpack_public_path__ + "media/drop.718b5c19.mp3";